import { createFileRoute, Outlet } from "@tanstack/react-router";

import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";
import { Tab, TabMenu } from "src/components/base/tab-menu";
import TabLayout from "src/components/base/tab-layout";
import { BackButton, Button } from "src/components/base/button";
import SINGLE_SUBNET_CONTEXT, { SingleSubnetProvider } from "src/context/internal/subnet";
import UpdateSubnetDialog from "src/components/dialogs/update-subnet";

/**
 * The properties for {@link SingleSubnetView}
 */
export type TagLayout = {};

/**
 * The Layout for a single subnet
 */
function SingleSubnetView(props: TagLayout) {
    const [t] = useTranslation("admin-subnet-view");

    const [editSubnet, setEditSubnet] = React.useState<boolean>(false);

    const { subnetId } = Route.useParams();

    return (
        <SingleSubnetProvider uuid={subnetId}>
            <SINGLE_SUBNET_CONTEXT.Consumer>
                {(ctx) => (
                    <div className={"flex flex-col gap-6"}>
                        <BackButton className={"self-start"} href={"/a/subnets/approved"}>
                            {t("button.back-to-subnet-overview")}
                        </BackButton>

                        <TabLayout
                            heading={t("heading.subnet", { subnet: ctx.subnet.name })}
                            headingDescription={ctx.subnet.description}
                            headingChildren={
                                <Button outline={true} onClick={() => setEditSubnet(true)}>
                                    {t("button.edit-description")}
                                </Button>
                            }
                            tabs={
                                <TabMenu>
                                    <Tab href={"/a/subnets/$subnetId/inbound-acls"} params={{ subnetId }}>
                                        {t("label.inbound-acls")}
                                    </Tab>
                                    <Tab href={"/a/subnets/$subnetId/outbound-acls"} params={{ subnetId }}>
                                        {t("label.outbound-acls")}
                                    </Tab>
                                </TabMenu>
                            }
                        >
                            <Outlet />
                        </TabLayout>

                        {editSubnet && (
                            <Suspense>
                                <UpdateSubnetDialog
                                    subnet={ctx.subnet}
                                    onSubmit={() => {
                                        setEditSubnet(false);
                                        ctx.reset();
                                    }}
                                    onClose={() => setEditSubnet(false)}
                                />
                            </Suspense>
                        )}
                    </div>
                )}
            </SINGLE_SUBNET_CONTEXT.Consumer>
        </SingleSubnetProvider>
    );
}

export const Route = createFileRoute("/_admin/a/subnets/$subnetId/_subnet")({
    component: SingleSubnetView,
});
